import { __assign } from "tslib";
import React, { useContext } from 'react';
import { getZeroIntersectionVisibility, calculateZeroIntersection, } from './zero-intersection.utils';
import { Line } from './elements';
import { ChartContext } from '../contexts';
export var ZeroIntersection = function (_a) {
    var xScale = _a.xScale, yScale = _a.yScale, _b = _a.layout, layout = _b === void 0 ? 'vertical' : _b;
    var _c = useContext(ChartContext), svgDimensions = _c.svgDimensions, margins = _c.margins, _d = _c.theme, gridX = _d.gridX, gridY = _d.gridY, zeroIntersection = _d.zeroIntersection;
    var isVisible = getZeroIntersectionVisibility(layout, xScale, yScale, gridX.enabled, gridY.enabled);
    var line = isVisible &&
        calculateZeroIntersection(layout, xScale, yScale, svgDimensions, margins);
    return (React.createElement(React.Fragment, null, isVisible && (React.createElement(Line, __assign({ "data-testid": "zero-intersection", color: zeroIntersection.color }, line)))));
};
export default ZeroIntersection;
